import { IDeleteChecklistEntregaAmbienteUseCase } from "../../../presentation/useCases/delete/delete_checklist_entrega_ambiente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteChecklistEntregaAmbienteUseCase
 */

export class DeleteChecklistEntregaAmbienteUseCase implements IDeleteChecklistEntregaAmbienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idChecklistEntregaAmbiente: number): Promise<void> {
    await this.repository.deleteChecklistEntregaAmbienteById(idChecklistEntregaAmbiente);
  }
}
